import { AddProduct } from "./AddProduct";

const EditProduct = () => <AddProduct editMode />;

export default EditProduct;
